"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAuditLogDto = void 0;
class CreateAuditLogDto {
    code;
    message;
    user_id;
    itinerary_id;
    session_id;
    request_id;
    target_user;
    entity_id;
    entity_type;
    source;
    pii;
    extra;
    org_id;
}
exports.CreateAuditLogDto = CreateAuditLogDto;
